import { create } from 'zustand';
// import { useLettersCountStore } from './getLettersCountStore';
import { ApiUtils } from '@shared/utils';
import { LettersApi } from '@shared/api';

interface UseDeleteLetterStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  deleteLetter: (id: string, request?: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDeleteLetterStore = create<UseDeleteLetterStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  deleteLetter: async (request, id, signal) => {
    try {
      set({ loading: true, error: null, data: false });
      await LettersApi.deleteLetter(request, id, signal);
      set({ loading: false, data: true });
      // useLettersCountStore.getState().get();
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  },

  clear: () => set({ loading: false, error: null, data: false }),
}));
